<template>
  <div>
    <section class="section-title-page container-fluid" style="background-image: url('img/bg_tramite.jpg')">
      <div class="container">
        <div class="wrapper">
          <h1>Buscar <small style="font-weight: 300"> Colegiado</small></h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/Servicios/">Servicios</a>
          </span>
        </div>
      </div>
    </section>
    <section class="section-page container-fluid">
      <div class="container service-selected-search">
        <div class="col p-0">
          <div class="bg-white rounded">
            <div class="p-3">
              <p class="m-0">
                (*) <strong>Verifica</strong> la información de miembros
                registrados y realiza consultas rápidas y seguras.
              </p>
            </div>
            <div class="form px-3 pt-0">
              <select ref="miSelect" @change="verifySelect($event.target.value)" class="form-control h-100">
                <option value="nombres">Nombres y Apellidos</option>
                <option value="numero_documento_identidad">N° Identidad</option>
                <option value="numero_colegiatura">N° CMVP</option>
              </select>
              <input type="text" ref="miInput" class="form-control" placeholder="Ingresar nombres y apellidos" />
              <button @click="searchCollegiate">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <div id="viewCollegiate">
            <div class="description w-100" v-if="!noResults && searchResults.length == 0">
              <p class="m-0 esperanding">Esperando consulta...</p>
            </div>
            <div v-if="noResults && searchResults.length != 0" class="not-found w-100">
              <p class="m-0">
                No se encontraron resultados <i class="fa far fa-sad-cry"></i>
              </p>
            </div>
            <div v-show="showTable" class="rounded bg-white mt-2 p-3 w-100">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead class="bg-black text-white">
                    <tr>
                      <th>Foto</th>
                      <th>Colegiado</th>
                      <th class="text-center">CMVP</th>
                      <th class="text-center">Estado</th>
                      <th class="text-center">Incorporación</th>
                      <!--
                      <th class="text-center">Especialización</th>
                      -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, k) in searchResults" :key="k">
                      <td>
                        <div class="photo-collegiate" :style="{
                          'background-image': 'url(' + value.foto + ')',
                        }"></div>
                      </td>
                      <td>
                        <div>
                          <strong>{{ value.colegiado }}</strong>
                        </div>
                      </td>
                      <td class="text-center">{{ value.numero_colegiatura }}</td>
                      <td class="text-center">{{ value.estado }}</td>
                      <td class="text-center">{{ value.incorporacion }}</td>
                      <!--
                      <td class="text-center">
                        <ul style="
                          list-style:circle;
                          text-align: left;
                          font-weight: 700;
                        ">
                          <li v-for="(val, key) in value.especialidades" :key="key">
                            {{ val.especialidad }}
                          </li>
                        </ul>
                      </td>
                      -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "busqueda_colegiado",
  computed: {
    ...mapState(["empresa"]),
  },
  data() {
    return {
      searchType: "",
      searchQuery: "",
      searchResults: [],
      loading: false,
      noResults: false,
      showTable: false,
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    verifySelect(value) {
      switch (value) {
        case 'nombres': this.$refs.miInput.placeholder = 'Ingresar nombres y apellidos'; break;
        case 'numero_documento_identidad': this.$refs.miInput.placeholder = 'Ingresar el DNI'; break;
        case 'numero_colegiatura': this.$refs.miInput.placeholder = 'Ingresar el CMVP'; break;
      }
    },
    searchCollegiate() {
      this.searchType = this.$refs.miSelect.value;
      this.searchQuery = this.$refs.miInput.value;

      if (this.searchQuery.trim()) {
        this.setLoading(true);
        this.$http
          .get(
            "ws_collegiate/search_collegiate?parametro=" +
            this.searchType +
            "&valor=" +
            this.searchQuery
          )
          .then((res) => {
            if (res.data.Resultado.length > 0) {
              this.searchResults = res.data.Resultado;
              this.noResults = false;
              this.showTable = true;
            } else {
              this.noResults = true;
              this.showTable = false;
            }
          })
          .finally(() => {
            this.setLoading(false);
          });
      }
    },
  },
};
</script>
